import React from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Buildings, HandHeart, Wrench, ShieldCheck } from "@phosphor-icons/react";

export default function AboutPage() {
  return (
    <div className="App">
      <Navbar />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16" data-testid="about-page">
        <div className="grid grid-cols-12 gap-8 items-start">
          <div className="col-span-12 md:col-span-7">
            <div className="label-uppercase">About AMPM</div>
            <h1 className="h1 text-5xl md:text-6xl mt-4">
              A small, independent landlord —
              <br />
              <span className="text-[var(--text-tertiary)]">looking after three Hull homes.</span>
            </h1>
            <p className="mt-8 text-lg text-[var(--text-secondary)] max-w-2xl">
              AMPM Property Investments is family-run. We don't manage hundreds of properties — we own three,
              we know each one inside out, and we take pride in keeping them in good condition for the
              people who live there.
            </p>
            <p className="mt-4 text-lg text-[var(--text-secondary)] max-w-2xl">
              Every property is deposit-protected, EPC-compliant, and gas-safety certified. When something
              breaks, we fix it quickly. When you call, you reach us — not a call centre.
            </p>
          </div>

          <div className="col-span-12 md:col-span-5">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1598369614922-3ea37bd4e3f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHx5b3VuZyUyMHByb2Zlc3Npb25hbCUyMHdvcmtpbmclMjBob21lfGVufDB8fHx8MTc4MTEwMjI0NHww&ixlib=rb-4.1.0&q=85"
                alt="Working from home"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[var(--bg-secondary)] border-y border-[var(--border-subtle)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
          <div className="label-uppercase">How we work</div>
          <h2 className="h2 text-4xl md:text-5xl mt-3 max-w-2xl">Four small promises.<br/> Kept, every tenancy.</h2>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Pillar icon={<Buildings size={28} />} title="Local & independent" body="Owner-managed in Hull. No portfolios, no franchises. You speak to us directly." />
            <Pillar icon={<HandHeart size={28} />} title="Fair tenancies" body="Reasonable referencing, transparent fees and deposit protection from day one." />
            <Pillar icon={<Wrench size={28} />} title="Fast on repairs" body="Trusted local trades. Urgent issues responded to within 24 hours." />
            <Pillar icon={<ShieldCheck size={28} />} title="Safety first" body="Annual gas safety, EICR-tested electrics, working alarms and EPC-compliant insulation." />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

const Pillar = ({ icon, title, body }) => (
  <div className="bg-white border border-[var(--border-subtle)] p-6">
    <div className="text-[var(--text-primary)]">{icon}</div>
    <h3 className="h3 text-xl mt-4">{title}</h3>
    <p className="text-sm text-[var(--text-secondary)] mt-2">{body}</p>
  </div>
);
